import { Box, ClickAwayListener, Popover } from "@mui/material";
import { Dashboard } from "../../../../../types/files";
import DescriptionContentCard from "../../../../molecules/home-companies/DescriptionContentCard";

const DescriptionModal: React.FC<{
    open: boolean,
    dashboard: Dashboard,
    anchorElement?: HTMLElement|null,
    onClose: () => void,
 }> = ({ open, dashboard, anchorElement, onClose }) => {
    return (<>
        <Popover open={open} anchorEl={anchorElement}>
            <ClickAwayListener onClickAway={onClose}>
                <Box width="fit-content" height="fit-content">
                    <DescriptionContentCard dashboard={dashboard} />
                </Box>
            </ClickAwayListener>
        </Popover>
    </>);
}

export default DescriptionModal;